module.exports = __webpack_public_path__ + "static/media/Icons for Digital Events_V1-02.20fad54b.svg";